import { IForm } from 'core-components/classes/models/IForm'

import {
  IContractSignatureProgress,
  ILRProgress,
  IProfilingProgress,
} from '../../features/models/progressDataModels'

export const mapProfilingProgress = (data: IForm): IProfilingProgress => ({
  changeContactRequests: data.changeContactRequests,
  changePartnerRequest: data.changePartnerRequest,
})

export const mapLRProgressData = (data: IForm): ILRProgress => ({
  approvalStatus: data.approvalStatus,
  internalApprovalStatus: data.internalApprovalStatus,
})

export const mapContractSignatureProgress = (data: IForm): IContractSignatureProgress => ({
  businessStatus: data.businessStatus,
  contractStatus: data.contractStatus || null,
})
